import React, { useEffect, useState } from 'react';
import './Container.scss';
import alabama from '../../assets/areaMap/al.png';
import alaska from '../../assets/areaMap/ak.png';
import arkansas from '../../assets/areaMap/ar.png';
import arizona from '../../assets/areaMap/az.png';
import california from '../../assets/areaMap/ca.png';
import colorado from '../../assets/areaMap/co.png';
import connecticut from '../../assets/areaMap/ct.png';
import delaware from '../../assets/areaMap/de.png';
import florida from '../../assets/areaMap/fl.png';
import georgia from '../../assets/areaMap/ga.png';
import hawaii from '../../assets/areaMap/hi.png';
import idaho from '../../assets/areaMap/id.png';
import illinois from '../../assets/areaMap/il.png';
import indiana from '../../assets/areaMap/in.png';
import iowa from '../../assets/areaMap/ia.png';
import kansas from '../../assets/areaMap/ks.png';
import kentucky from '../../assets/areaMap/ky.png';
import louisiana from '../../assets/areaMap/la.png';
import maine from '../../assets/areaMap/me.png';
import maryland from '../../assets/areaMap/md.png';
import massachusetts from '../../assets/areaMap/ma.png';
import michigan from '../../assets/areaMap/mi.png';
import minnesota from '../../assets/areaMap/mn.png';
import mississippi from '../../assets/areaMap/ms.png';
import missouri from '../../assets/areaMap/mo.png';
import montana from '../../assets/areaMap/mt.png';
import nebraska from '../../assets/areaMap/ne.png';
import nevada from '../../assets/areaMap/nv.png';
import newHampshire from '../../assets/areaMap/nh.png';
import newJersey from '../../assets/areaMap/nj.png';
import newMexico from '../../assets/areaMap/nm.png';
import newYork from '../../assets/areaMap/ny.png';
import northCarolina from '../../assets/areaMap/nc.png';
import northDakota from '../../assets/areaMap/nd.png';
import ohio from '../../assets/areaMap/oh.png';
import oklahoma from '../../assets/areaMap/ok.png';
import oregon from '../../assets/areaMap/or.png';
import pennsylvania from '../../assets/areaMap/pa.png';
import rhodeIsland from '../../assets/areaMap/ri.png';
import southCarolina from '../../assets/areaMap/sc.png';
import southDakota from '../../assets/areaMap/sd.png';
import tennessee from '../../assets/areaMap/tn.png';
import texas from '../../assets/areaMap/tx.png';
import utah from '../../assets/areaMap/ut.png';
import vermont from '../../assets/areaMap/vt.png';
import virginia from '../../assets/areaMap/va.png';
import washington from '../../assets/areaMap/wa.png';
import westVirginia from '../../assets/areaMap/wv.png';
import wisconsin from '../../assets/areaMap/wi.png';
import wyoming from '../../assets/areaMap/wy.png';
import reset from '../../assets/reset.svg';

const statesImg = {
  alabama: alabama,
  alaska: alaska,
  arkansas: arkansas,
  arizona: arizona,
  california: california,
  colorado: colorado,
  connecticut: connecticut,
  delaware: delaware,
  florida: florida,
  georgia: georgia,
  hawaii: hawaii,
  idaho: idaho,
  illinois: illinois,
  indiana: indiana,
  iowa: iowa,
  kansas: kansas,
  kentucky: kentucky,
  louisiana: louisiana,
  maine: maine,
  maryland: maryland,
  massachusetts: massachusetts,
  michigan: michigan,
  minnesota: minnesota,
  mississippi: mississippi,
  missouri: missouri,
  montana: montana,
  nebraska: nebraska,
  nevada: nevada,
  newHampshire: newHampshire,
  newJersey: newJersey,
  newMexico: newMexico,
  newYork: newYork,
  northCarolina: northCarolina,
  northDakota: northDakota,
  ohio: ohio,
  oklahoma: oklahoma,
  oregon: oregon,
  pennsylvania: pennsylvania,
  rhodeIsland: rhodeIsland,
  southCarolina: southCarolina,
  southDakota: southDakota,
  tennessee: tennessee,
  texas: texas,
  utah: utah,
  vermont: vermont,
  virginia: virginia,
  washington: washington,
  westVirginia: westVirginia,
  wisconsin: wisconsin,
  wyoming: wyoming
};

function MapMobile({ currentStateName, buttonActive, handleClickNavButtons }) {
  const [currentSrc, setCurrentSrc] = useState();

  useEffect(() => {
    const createSrc = (name) => {
      const index = name.indexOf(' ');
      let newName = '';
      for (let i = 0; i < name.length; i++) {
        if (i === 0) {
          newName += name[i].toLowerCase();
        } else if (index > 0 && i === index + 1) {
          newName += name[i].toUpperCase();
        } else if (i !== index) {
          newName += name[i];
        }
      }
      return newName;
    };

    if (currentStateName) {
      const state = createSrc(currentStateName);
      setCurrentSrc(statesImg[state]);
    }
  }, [currentStateName]);

  return (
    <section className="mapMobile">
      <img
        className="mapMobile__reset reset"
        src={reset}
        alt="Click to reset the map"
        onClick={() => {
          handleClickNavButtons(buttonActive);
        }}
      />
      <img src={currentSrc} alt={`map of ${currentStateName}`} className="mapMobile__stateMap" />
    </section>
  );
}

export default MapMobile;
